"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneMuted = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneMuted_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.854.854a.5.5 0 0 0-.708-.708l-15 15a.5.5 0 0 0 .708.708l3.41-3.41A13.287 13.287 0 0 0 13.334 16c1.44-.009 2.666-1.226 2.666-2.666v-1.779c0-.981-.796-1.777-1.778-1.777h-1.561c-.708 0-1.386.28-1.886.781l-.72.72a.907.907 0 0 1-.637.267.822.822 0 0 1-.364-.084A9.813 9.813 0 0 1 6.78 9.927L15.854.854Zm-9.782 9.78-1.1 1.102A12.29 12.29 0 0 0 13.33 15c.897-.007 1.67-.785 1.67-1.666v-1.779a.778.778 0 0 0-.778-.777h-1.561c-.443 0-.866.175-1.178.488h-.001l-.72.72a1.921 1.921 0 0 1-1.344.56c-.27 0-.546-.06-.805-.186a10.8 10.8 0 0 1-2.54-1.725Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.538 6.947c.257.526.559 1.026.9 1.493l-.714.715a10.788 10.788 0 0 1-1.084-1.77c-.366-.75-.163-1.609.375-2.147l.72-.72c.312-.312.487-.736.487-1.178V1.778A.778.778 0 0 0 4.445 1H2.667c-.46 0-.875.187-1.177.49A1.66 1.66 0 0 0 1 2.666c0 2.868.976 5.505 2.614 7.599l-.712.711A13.28 13.28 0 0 1 0 2.666C0 1.93.302 1.262.782.782A2.66 2.66 0 0 1 2.667 0h1.778c.981 0 1.777.796 1.777 1.778V3.34c0 .707-.28 1.386-.78 1.886l-.72.719a.882.882 0 0 0-.184 1.002Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneMuted_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneMuted;
exports["default"] = _default;